import { atom } from 'jotai';

/** Per-form force-validation flags. Set to true to trigger validation display. */
export const forceValidateDmsConnectionAtom = atom(false);
export const forceValidateBusinessIdentityAtom = atom(false);
export const forceValidateBusinessAddressesAtom = atom(false);
export const forceValidateBusinessContactAtom = atom(false);
export const forceValidateBankAccountDetailsAtom = atom(false);
